import type { CardEvent, Redemption } from "../../../../packages/shared/src/types";
import { t as msg, currentLocale, formatNumber } from "../lib/i18n";
import { Thanks } from "./Thanks";
const labels: Record<CardEvent["kind"], string> = {
  sent: "Sent", delivered: "Delivered", accepted: "Accepted",
  redemption_requested: "Redemption requested", redemption_withdrawn: "Request withdrawn", reminded: "Reminder sent",
  completed: "Completed", revoked: "Revoked", declined: "Declined", expired: "Expired",
};
export function CardTimeline({ events, history = [], canThank = false, featuredThanksId, onSaved }: {
  events: CardEvent[]; history?: Redemption[]; canThank?: boolean; featuredThanksId?: string; onSaved?: (redemption: Redemption) => void;
}) {
  if (!events?.length) return null;
  const date = new Intl.DateTimeFormat(currentLocale(), {dateStyle:"medium",timeStyle:"short"});
  return <details className="card-activity card-disclosure">
    <summary>{msg("Card activity")}</summary>
    <ol>{[...events].reverse().map(event => {
      const completed = event.kind === "completed" ? history.find(r => r.status === "completed" && r.useIndex === event.useIndex) : undefined;
      return <li key={event.id}>
        <div className="activity-event"><span>{msg(labels[event.kind])}{event.useIndex !== undefined && <small>{msg("Promise #{p0}", {p0:formatNumber(event.useIndex)})}</small>}</span><time dateTime={event.at}>{date.format(new Date(event.at))}</time></div>
        {completed && <>{(completed.reactionEmoji || completed.reactionText) && <p className="activity-thanks">{completed.reactionEmoji} {completed.reactionText}</p>}{canThank && completed.id !== featuredThanksId && onSaved && <Thanks redemption={completed} onSaved={onSaved} />}</>}
      </li>;
    })}</ol>
  </details>;
}
